import { Calendar, ICalaendarType } from '../features/calendar/calendar-slice';
import { ServiceSteps } from '../features/product/product-slice';
import { api } from './api.service';
import { IHealthPlanInsurance } from './healthPlan.service';

interface IProductQuery {
  id: string | undefined;
  doctorId?: string | undefined;
}

export interface IProductResult {
  id: string;
  active: boolean;
  services: string[];
  servicesSteps: Array<ServiceSteps>;
  price: number;
  isNeedAddress: boolean;
  maxInstallment: number;
  urlAnamnese: string;
  sendAnamnese: boolean;
  calendars: Calendar[];
  name: string;
  alias: string;
  calendarTypes: Array<ICalaendarType>;
  healthPlan: Array<IHealthPlanInsurance>;
  durationTime: number;
  doctorName: string;
  hasTimeLimitSchedule: boolean;
}

export const product = api.injectEndpoints({
  endpoints: build => ({
    getProductDetails: build.mutation<IProductResult, IProductQuery>({
      query: ({ id, doctorId }) => ({
        url: `/product/${id}${doctorId ? `/${doctorId}` : ''}`
      })
    })
  })
});

export const { useGetProductDetailsMutation } = product;
